angular.module('dpw.components')
    /**
     * @ngdoc component
     * @name dpwBanner
     * @restrict E
     * @param {string} page
     * @param {object} pageTexts
     * @description
     * Display banner for pages.
     * @example
     * <dpw-banner page="index"></dpw-banner>
     */
    .component('dpwBanner', {
        templateUrl: 'dpw-banner.html',
        bindings: {
            page: '@',
            pageTexts: '<'
        },
        controllerAs: 'bannerCtrl',
        controller: [function () {
            var bannerCtrl = this;
            var pageBannerConfigs = {

                // Home Page
                index: RCDPW.isLogin ?
                    buildGeneralBannerConfig({ extraClass: 'index-banner-afterLogin' }) :
                    buildGeneralBannerConfig({
                      extraClass: 'index-banner-beforeLogin',
                      withFreeSignUp: true
                    }),

                // Use Cases Overview Page.
                useCase: buildGeneralBannerConfig({ extraClass: 'overview-banner' }),

                developerEvents: {
                    extraClass: ['general-banner', 'developer-events-banner'],
                    showHeroDescription: false,
                    image: 'banner_developer_events.png'
                },

                community: {
                    extraClass: ['general-banner', 'community-banner'],
                    showHeroDescription: false,
                    image: 'banner_community.png'
                }
            };

            bannerCtrl.heroHeaderDefaults = RCDPW.Lang.Contentful.HomePage.heroHeader;
            bannerCtrl.heroDescriptionDefaults = RCDPW.Lang.Contentful.HomePage.heroDescription;
            bannerCtrl.bannerConfig = pageBannerConfigs[bannerCtrl.page];

            function buildGeneralBannerConfig(options) {
                options = options || {};

                return {
                    extraClass: options.extraClass,
                    image: 'general-banner-image.png',
                    showHeroDescription: true,
                    withFreeSignUp: options.withFreeSignUp
                };
            }
        }]
    });
